/**
 * Manages the download links for Resource Item downloadable items that can be in multiple languages,
 * with or without versions.
 */
/*jshint esversion: 6 */  // turns off warnings about const and let
/*jshint sub:true*/       // turns off "...is better written in dot notation"
(function($) {
  'use strict';
  //console.log(" In jquery.downloadable-item-by-lang_and_version.js");
  $( document ).on( 'ready', function () {

    $(".downloadable--wrap").each( function( index ) {
      /*
      payload is a JSON-encoded array of items stored in a data attribute that define the select box relationships. It
      is embedded by the DownloadableItem class. See class-DownloadableItemOutput.php for how this is sent.

      Example at end of this file.
       */
      lang_and_version__initial_load( $, $( this ).data( 'post-payload' ), index );
    });
  });
})(jQuery);



/**
 * Does the initial setup for each downloadable item.
 *
 * @param $                      object   jQuery object
 * @param item_as_sent   array  The array of properties for this DI.
 * @param index          int    The current index in the forEach loop
 */
function lang_and_version__initial_load( $, item_as_sent, index ) {
  'use strict';
  //console.log( index );

  // Get the array key, given we know there is only one at this point.
  const item          = item_as_sent[0];
  const post_id       = Object.keys( item );
  const post_id_class = '.id_' + post_id;
  const doing_ver     = item[ post_id ][ 'switches' ][ 'doing_versions' ];

  //Start by hiding all the download links
  $( post_id_class + ' .downloadable-item' ).hide();

  //When a user selects a different language from the dropdown, show that language's download link
  $( post_id_class + ' .id_language_picker' ).change( function () {
    //console.log( post_id + " Language Changed" );
    // Reset any of the other container divs that were previously marked 'active'
    $( 'div.resource_item' ).removeClass( "active" );
    // For the dropdown that just changed, mark the containing div as 'active'
    $( this ).closest( 'div.resource_item' ).addClass( "active" );
    if ( doing_ver ) {
      // Hide all buttons
      $( '.active .downloadable-item' ).hide();

      // Fix the dropdown for the Versions picker, which will now need to be updated based on the language selected
      lang_and_version__fix_dropdown( $, item, post_id, post_id_class, '.id_versions_picker', '.id_language_picker' );
      // Enable the correct button for the lang + ver combination
      lang_and_version__enable_correct_button( $, item, post_id_class );

      lang_and_version__check_for_single_options( $, post_id_class + ' .id_versions_picker' );
    } else {
      //console.log( "Not Doing Versions" );
      // Hide all the buttons
      $( '.active .buttons' ).find( "a" ).closest( 'div' ).hide();
      // Reveal only the button that matches the selection
      $( '.active .buttons' ).find( '.id_' + $( this ).val() ).closest( 'div' ).show();
    }
  } );


  // When a user selects a different language from the dropdown, show that language's download link
  $( post_id_class + ' .id_versions_picker' ).change( function () {
    //console.log( post_id + " Version Changed" );
    // Reset any of the other container divs that were previously marked 'active'
    $( 'div.resource_item' ).removeClass( "active" );
    // For the dropdown that just changed, mark the containing div as 'active'
    $( this ).closest( 'div.resource_item' ).addClass( "active" );

    // Always doing ver if here, so hide all the buttons
    $( '.active .downloadable-item' ).hide();
    // Fix the dropdown for the language picker, which will now need to be updated based on the Versions selected
    //lang_and_version__fix_dropdown( $, item, post_id, post_id_class, '.id_language_picker', '.id_versions_picker' );
    // Enable the correct button for the lang + ver combination
    lang_and_version__enable_correct_button( $, item, post_id_class );
  } );

  //console.log("Manually triggering the language selector to rebuild the version selector");

  // If the site language is not found in the list of the languages for a DI, use the first one.
  // Otherwise use the found one.
  const di_langs = item[post_id]['selected'];
  const site_lang = item[post_id]['switches']['site_lang'];
  if ( typeof di_langs[site_lang] === 'undefined' ) {
    $( post_id_class + ' .id_language_picker' ).val($(post_id_class + ' .id_language_picker').val()).change();
  } else {
    $( post_id_class + ' .id_language_picker' ).val(item[post_id]['switches']['site_lang']).change();
  }
}



/**
 * Disables a select box if there is only one option.
 *
 * @param $                      object   jQuery object
 * @param select_box
 */
function lang_and_version__check_for_single_options( $, select_box ) {
  'use strict';
  $( select_box ).prop('disabled', false);
  if ( 1 === $( select_box ).children('option').length ) {
    $( select_box ).prop('disabled', 'disabled');
  }
}


/**
 * General function to adjust the dropdown
 * @param $                      object   jQuery object
 * @param item                   array    The array of properties for this DI.
 * @param post_id                string   Post ID
 * @param post_id_class          string   Post ID formatted as the class selecter
 * @param dropdown_to_fix        string   The class selector for the dropdown the reset and reload
 * @param dropdown_that_changed  string   The class selector for the dropdown that was changed
 */
function lang_and_version__fix_dropdown( $, item, post_id, post_id_class, dropdown_to_fix, dropdown_that_changed ) {
  'use strict';
  // If we are here, then the language dropdown was just changed.
  // Rebuild the Versions options to valid ones. What are the valid ones? that is found in payload.
  const selected = $( post_id_class + '.active ' + dropdown_that_changed ).find( ":selected" ).val();
  //console.log( "Rebuilding " + selected );
  //console.log( post_id_class + '.active ' + dropdown_that_changed );
  const type = ( '.id_language_picker' === dropdown_to_fix ) ? 'by_ver' : 'by_lang';

  // clear all options from Versions select
  $( post_id_class + '.active ' + dropdown_to_fix )
    .find( 'option' )
    .remove()
    .end();

  // Re-create them
  // @src https://stackoverflow.com/questions/740195/adding-options-to-a-select-using-jquery
  Object.keys( item[ post_id ][ type ][ selected ] ).forEach( function ( selected, index ) {
    //console.log( "  Adding " + item[ post_id ][ 'labels' ][ selected ] + "(" + selected + ")" );
    let o = new Option( item[ post_id ][ 'labels' ][ selected ], selected );
    // jquerify the DOM object 'o' so we can use the html method
    jQuery( o ).html();
    jQuery( '.active ' + dropdown_to_fix ).append( o );
  } );

  // Set the active version from the active array set as part of item
  jQuery( '.active ' + dropdown_to_fix ).get(0).selectedIndex = item[ post_id ][ 'selected' ][ selected ];
}



/**
 * Find the correct button based on selections made in the UI
 *
 * @param $                      object   jQuery object
 * @param item                   array    The array of properties for this DI.
 * @param post_id_class          string   Post ID formatted as the class selector
 * @param is_initial_load        bool     true if it's the page load case; false otherwise. Default false
 */
function lang_and_version__enable_correct_button( $, item, post_id_class, is_initial_load = false ) {
  //console.log( "Finding Button" );
  let class_id = post_id_class;
  if ( !is_initial_load ) {
    class_id += '.active';
  }
  // Get selected lang
  const selected_lang = $( class_id + ' .id_language_picker' ).find( ":selected" ).val();
  //console.log( "  Lang: " + selected_lang );
  //console.log( "  " + class_id + ' .id_language_picker' );

  // Get selected ver
  const selected_ver = $( class_id + ' .id_versions_picker' ).find( ":selected" ).val();
  //console.log( "  Ver: " + selected_ver );

  // Now activate the correct button
  $( class_id + ' .id_' + selected_lang + '__' + selected_ver ).closest( 'div' ).show();
}

/*
payload structure
      <post_id> (array):
        by_lang (array):
          <language code> (array):
            <size taxonomy slug 1>: <button ID for this size and language combination (string)
            <size taxonomy slug 2>: <button ID for this size and language combination (string)
        by_ver (array):
          <size taxonomy slug> (array):
            <language code 1>: <button ID for this size and language combination (string)
            <language code 2>: <button ID for this size and language combination (string)
        selected (array):
          <lang code> (array):
            <int>: the index for the item that is determined to be "current"
        labels (array):
          <size taxonomy slug 1>: <size taxonomy label 1> (string)
          <language code 1>: <language code 1> (string)
        switches (array):
          doing_versions: BOOL (bool)
          post_id: <post ID> (string)

    Notes:
    1. There can be any number of lang and dim entries, and they may not be of equal size.
    2. The labels are already localized

Example payload

[
	{
		"79686": {
			"labels": {
				"en": "English",
				"1_2": "1.2",
				"1_5": "1.5",
				"pt-br": "Portuguese",
				"1_1": "1.1",
				"es": "Spanish",
				"fr": "French",
				"1_0": "1.0",
				"zh-hans": "Chinese (Simplified)",
				"vi": "Vietnamese",
				"tr": "Turkish",
				"it": "Italian",
				"id": "Indonesian",
				"ja": "Japanese",
				"de": "German"
			},
			"by_lang": {
				"en": {
					"1_2": "en__1_2",
					"1_5": "en__1_5"
				},
				"pt-br": {
					"1_1": "pt-br__1_1"
				},
				"es": {
					"1_1": "es__1_1"
				},
				"fr": {
					"1_0": "fr__1_0"
				},
				"zh-hans": {
					"1_0": "zh-hans__1_0"
				},
				"vi": {
					"1_0": "vi__1_0"
				},
				"tr": {
					"1_1": "tr__1_1"
				},
				"it": {
					"1_0": "it__1_0"
				},
				"id": {
					"1_1": "id__1_1"
				},
				"ja": {
					"1_1": "ja__1_1"
				},
				"de": {
					"1_1": "de__1_1"
				}
			},
			"by_ver": {
				"1_2": {
					"en": "en__1_2"
				},
				"1_5": {
					"en": "en__1_5"
				},
				"1_1": {
					"pt-br": "pt-br__1_1",
					"es": "es__1_1",
					"tr": "tr__1_1",
					"id": "id__1_1",
					"ja": "ja__1_1",
					"de": "de__1_1"
				},
				"1_0": {
					"fr": "fr__1_0",
					"zh-hans": "zh-hans__1_0",
					"vi": "vi__1_0",
					"it": "it__1_0"
				}
			},
			"selected": {
				"en": 1,
				"pt-br": 0,
				"es": 0,
				"fr": 0,
				"zh-hans": 0,
				"vi": 0,
				"tr": 0,
				"it": 0,
				"id": 0,
				"ja": 0,
				"de": 0
			},
			"switches": {
				"doing_versions": true,
				"post_id": 79686
			}
		}
	}
]
 */
